import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { has, isEmpty } from 'lodash';
import Icon from "../../Icon/Icon";
import getIcon from "../utils/getIcon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServiceType = _ref => {
  let {
    serviceType,
    level,
    showIcon,
    iconColor
  } = _ref;
  const itemClass = () => cn({
    'mb-4 text-purple px-4 inline-block font-heavy-font': level <= 0,
    'mb-1.5 text-text-blue font-regular-font': level > 0
  });
  return /*#__PURE__*/_jsxs("li", {
    className: itemClass(),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex",
      children: [showIcon && /*#__PURE__*/_jsx("span", {
        className: "pl-6 mr-2 flex items-center",
        children: /*#__PURE__*/_jsx(Icon, {
          icon: getIcon(serviceType.code),
          color: iconColor,
          size: 18
        })
      }), /*#__PURE__*/_jsx("span", {
        children: serviceType.name
      })]
    }), has(serviceType, 'children') && !isEmpty(serviceType.children) && /*#__PURE__*/_jsx("ul", {
      className: "my-1.5 list-disc",
      children: serviceType.children.map(st => /*#__PURE__*/_jsx(ServiceType, {
        serviceType: st,
        level: level + 1,
        showIcon: false,
        iconColor: iconColor
      }, "app-components-service-type-".concat(level, "-").concat(st.code)))
    })]
  });
};
ServiceType.propTypes = {
  iconColor: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  serviceType: PropTypes.shape({
    children: PropTypes.array,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  showIcon: PropTypes.bool.isRequired
};
export default ServiceType;
//# sourceMappingURL=ServiceType.js.map